import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { removeOverlay as removeOverlayAction } from '../Actions/Overlay.action';
import { useTypedSelector } from '../Hooks/useTypedSelector';
import { getColor } from '../styling/mixins/colors';

const OVERLAY_CLASS = 'overlay';

const StyledOverlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
  animation: 0.2s ease-in-out 0s both 1 fade-in;
  -webkit-animation: 0.2s ease-in-out 0s both 1 fade-in;
  background-color: ${getColor('overlay')};
  opacity: 1;
`;

const Overlay = () => {
  const dispatch = useDispatch();

  const { activeOverlays, disableOverlayClick } = useTypedSelector(
    (state) => state.overlay
  );

  const removeOverlay = (componentName: string) =>
    dispatch(removeOverlayAction(componentName));

  const overlayClasses = activeOverlays
    ? activeOverlays.map((c) => `${OVERLAY_CLASS}--${c.name}`)
    : [];
  /**
   * Adds overlay classes to body to enable styling on components based on active overlays
   */
  useEffect(() => {
    // Remove all overlay classes that are not active anymore, before adding new
    const classesToRemove = Array.from(document.body.classList).filter(
      (c) => c.startsWith(OVERLAY_CLASS) || c == OVERLAY_CLASS
    );
    if (classesToRemove && classesToRemove.length > 0) {
      for (let className of classesToRemove) {
        document.body.classList.remove(className);
      }
    }

    // Add overlay classes to body
    if (activeOverlays && activeOverlays.length > 0) {
      for (let className of overlayClasses) {
        document.body.classList.add(className);
      }
    }
  }, [activeOverlays]);

  /**
   * Removes all overlays.
   * Triggers onOverLay click on all active overlay components
   */
  const onOverlayClick = useCallback(() => {
    if (disableOverlayClick) return;

    for (let component of activeOverlays) {
      if (component.onOverlayClick) {
        if (component.onOverlayClick() !== false) {
          removeOverlay(component.name);
        }
      }
    }
  }, [activeOverlays, disableOverlayClick]);

  return (
    activeOverlays &&
    activeOverlays.length > 0 && (
      <StyledOverlay
        className={`${OVERLAY_CLASS} ${overlayClasses.join(' ')}`}
        onClick={onOverlayClick}
      />
    )
  );
};

export default Overlay;
